import { api } from 'src/common/axiosInstance';
import { API_URL, FORGOTPASSWORD, RESETPASSWORD, SIGNIN, SIGNUP } from 'src/common/constants';
import { handleErrors } from 'src/common/utils';


const BASEAPI_URL = API_URL

// Define types for the responses
interface SignUpResponse {
    email: string;
}

interface SignInResponse {
    email: string;
}

interface ResetPasswordResponse {
    message: string;
}

interface ForgetPasswordResponse {
    message: string;
}

// API functions
export const apiSignUp = async (credentials: { email: string; password: string }): Promise<SignUpResponse> => {
    try {
        const response = await api.post((SIGNUP), credentials);
        return response.data;
    } catch (error) {
        throw new Error(handleErrors(error));
    }
};

export const apiSignIn = async (data: { email: string; password: string }): Promise<SignInResponse> => {
    try {
        const response = await api.post(`${BASEAPI_URL}` + `${SIGNIN}`, data,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        throw new Error(handleErrors(error));
    }
};

export const apiResetPassword = async (email: string): Promise<ResetPasswordResponse> => {
    try {
        const response = await api.post((RESETPASSWORD), { email });
        return response.data;
    } catch (error) {
        throw new Error(handleErrors(error));
    }
};

export const apiForgetPassword = async (email: string): Promise<ForgetPasswordResponse> => {
    try {
        const response = await api.post((FORGOTPASSWORD), { email });
        return response.data;
    } catch (error) {
        throw new Error(handleErrors(error));
    }
};
